import moment from 'moment';
import { STORAGE } from '../../constants';
import { LocalStorageService } from '../../services/local-storage.service';

export const LogData = async (data: any, buttonId: string, url: string) => {
  const session = LocalStorageService.get(STORAGE.SESSION);

  const log = {
    data_sent: data,
    button_id: buttonId,
    endPoint: url,
    data_user: {
      username: session.username,
      profile: session.profile,
      full_name: session.full_name,
      email: session.email
    },
    date: moment().format('YYYY-MM-DD HH:mm:ss')
  };

  return log;
};
export default LogData;
